import styled from '@emotion/styled';
import { LazyImageSilk } from 'src/domains/sportsbook/webview/components/lazyImage/LazyImageSilk';

export const WidgetSilkBox = styled(LazyImageSilk, { label: 'WidgetSilkBox' })`
    flex: 0 0 36px;
    height: 100%;
    width: 36px;
`;
